<template>
  <v-container fluid class="price-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-price`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-currency-usd</v-icon>
            Price
          </v-tab>
          <v-tab
            :href="`#tab-foc`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-currency-usd</v-icon>
            FOC
          </v-tab>

          <v-tab-item
            :value="'tab-price'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">Edit Price</p>
                      <v-select
                        class="mb-4"
                        :items="pricelists.map(x => {
                            return {text: x.pricelistname, value: x._id};
                          })"
                        :value="initvalue.pricelistid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'pricelistid')"
                        placeholder="Price List"
                        persistent-hint
                        single-line hint="Please choose the price list">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="items.map(x => {
                            return {text: x.itemname, value: x._id};
                          })"
                        :value="initvalue.itemid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemid')"
                        placeholder="Item"
                        persistent-hint
                        single-line hint="Please choose the item">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'pricename')"
                        v-bind:value="initvalue.pricename"
                        placeholder="Price Name"
                        persistent-hint
                        single-line hint="Enter the price name">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'minqty')"
                        v-bind:value="initvalue.minqty"
                        placeholder="Min Qty"
                        persistent-hint
                        single-line hint="Enter the minimum quantity">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'maxqty')"
                        v-bind:value="initvalue.maxqty"
                        placeholder="Max Qty"
                        persistent-hint
                        single-line hint="Enter the maximum quantity">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'listprice')"
                        v-bind:value="initvalue.listprice"
                        placeholder="List Price"
                        persistent-hint
                        single-line hint="Enter the list price">
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6" sm="3">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/price/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPrice()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-foc'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit FOC</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedFoc($event, 'itemqty')"
                        :value="initvalue.foc.itemqty"
                        placeholder="Item Qty"
                        persistent-hint
                        single-line hint="Enter the required item quantity">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedFoc($event, 'getitemqty')"
                        :value="initvalue.foc.getitemqty"
                        placeholder="Foc Item Qty"
                        persistent-hint
                        single-line hint="Enter the item FOC quantity">
                      </v-text-field>
                      <v-switch
                        v-model="foc.enable"
                        :label="foc.enable==true ? 'true' : 'false'"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=foctype
                        :value="initvalue.foc.type"
                        outlined
                        dense
                        v-on:change="updateChangedFoc($event, 'type')"
                        placeholder="FOC Item Type"
                        persistent-hint
                        single-line hint="Please choose the FOC Item Type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="items.map(x => {
                            return {text: x.itemname, value: x._id};
                          })"
                        :value="initvalue.foc.itemid"
                        outlined
                        dense
                        v-on:change="updateChangedFoc($event, 'itemid')"
                        placeholder="Item"
                        persistent-hint
                        single-line hint="Please choose the FOC item">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="itemsubcategories.map(x => {
                            return {text: x.itemsubcategoryname, value: x._id};
                          })"
                        :value="initvalue.foc.itemsubcategoryid"
                        outlined
                        dense
                        v-on:change="updateChangedFoc($event, 'itemsubcategoryid')"
                        placeholder="Item Subcategory"
                        persistent-hint
                        single-line hint="Please choose the FOC item subcategory">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/price/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editFoc()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      price: {},
      foc: {
          itemqty: 0,
          getitemqty: 0,
          enable: false,
      },
      foctype: ['Item', 'Subcategory Item'],
      initvalue: {
        foc: {
          itemqty: 0,
          getitemqty: 0,
        }
      },
    }
  },
  methods: {
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('ItemSubcategory', ['getItemSubcategoriesRequest']),
    ...mapActions('Price', ['updatePriceRequest','updatePriceImageRequest','updatePricePinRequest','getPricesRequest']),
    checkError(){
      if(this.foc.vaccinationstatus=='Subcategory Item' && (this.foc.itemsubcategory==null)){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    editPrice() {
      this.price._id = this.initvalue._id;
      this.updatePriceRequest(this.price);
      this.getPricesRequest();
      router.push('/price/list');
    },
    editFoc() {
      if(this.checkError() == false) return;
      let json = {}
      json._id = this.initvalue._id;
      json.foc = this.foc;
      console.log("HERE",json);
      this.updatePriceRequest(json);
      this.getPricesRequest();
      router.push('/price/list');
    },
    updateChangedValue(value, field){
      this.price[field] = value;
    },
    updateChangedFoc(value, field){
      this.foc[field] = value;
    },
  },
  computed: {
    ...mapState('Item', ['items']),
    ...mapState('ItemSubcategory', ['itemsubcategories']),
    ...mapState('Price', ['isReceiving']),
    ...mapState('PriceList', ['pricelists']),
  },
  created () {
    this.initvalue = this.$route.params;
    this.foc = this.initvalue.foc;
    if(!this.initvalue._id) {this.$router.push({ name: 'PriceList' })}
    if(this.items.length) {this.getItemsRequest()}
    if(this.itemsubcategories.length==0) {this.getItemSubcategoriesRequest()}
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
